import React from 'react'
import createReactClass from 'create-react-class'

const MgStatsFooter = createReactClass({
	render() {
		const { cancel } = this.props
		return <span>
			<div className="col-xs-12 col-md-12 bv-plan-container bv-account-settings-billing center-dom text-center">
				<div className="col-xs-9 col-md-9 center-dom">
					<a className="bv-secondary-button" onClick={cancel} style={{ marginLeft: "0" }}>Cancel Migration</a>
				</div>
			</div>
		</span>
	}
})

export default MgStatsFooter
